import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';

import { I18nModule } from '@recruitee/i18n';

import { DialogBodyModule } from '../../dialog/dialog-body/dialog-body.module';
import { DialogFooterModule } from '../../dialog/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '../../dialog/dialog-header/dialog-header.module';
import { CheckboxModule } from '../../forms/checkbox/checkbox.module';
import { FormFieldModule } from '../../forms/form-field/form-field.module';
import { InputModule } from '../../forms/input/input.module';
import { AvatarModule } from '../avatar/avatar.module';
import { BoxModule } from '../box/box.module';
import { ButtonModule } from '../button/button.module';
import { DividerModule } from '../divider/divider.module';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { GroupModule } from '../group/group.module';
import { HeadingModule } from '../heading/heading.module';
import { IconModule } from '../icon/icon.module';
import { PipesModule } from '../pipes/pipes.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { AdminsSelectDialogFormComponent } from './admins-select-dialog-form.component';

@NgModule({
  imports: [
    AvatarModule,
    BoxModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DialogBodyModule,
    DialogFooterModule,
    DialogHeaderModule,
    DividerModule,
    EmptyStateModule,
    FormFieldModule,
    ReactiveFormsModule,
    GroupModule,
    HeadingModule,
    I18nModule,
    IconModule,
    InputModule,
    PipesModule,
    SpinnerModule,
    VirtualScrollerModule,
  ],
  declarations: [AdminsSelectDialogFormComponent],
  exports: [AdminsSelectDialogFormComponent],
})
export class AdminsSelectDialogFormModule {}

export { AdminsSelectDialogFormComponent };
